// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3DAEH","header":"MessagesList_header__3TXv9","chat":"MessagesList_chat__3bDpx"};